import {
  IonBreadcrumb,
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonNote,
  IonPopover,
  IonSearchbar,
  IonTitle,
  IonToolbar,
  useIonAlert,
} from "@ionic/react";
import {
  logOutOutline,
  notificationsOutline,
  searchOutline,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useAuth } from "../pages/auth/AuthContext";

const HeaderComponent = (props: any) => {
  const [isThisBigScreen, setIsThisBigScreen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("Renon");
  const [presentAlert] = useIonAlert();
  let { logOut } = useAuth()!;
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 768px)",
  });

  useEffect(() => {
    if (isDesktopOrLaptop !== isThisBigScreen) {
      setIsThisBigScreen(isDesktopOrLaptop);
      setHeaderTitle(props.title);
    }
  });

  const showPopUp = () => {
    return presentAlert({
      header: "Are you sure you want to LogOut?",
      message: "Click CANCEL to close",
      buttons: [
        {
          text: "OK",
          role: "confirm",
          handler: async () => {
            await logOut();
          },
        },
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {
            //do nothing
          },
        },
      ],
    });
  };

  return (
    <IonHeader mode="md">
      <IonToolbar className="customHeader" mode="md">
        <IonButtons slot="start">
          <IonMenuButton
            autoHide={true}
            id="menuClick"
            mode="md"
            onClick={() => {}}
          />
        </IonButtons>
        <IonTitle>
          {isThisBigScreen && (
            <IonBreadcrumb color="primary">{headerTitle}</IonBreadcrumb>
          )}
        </IonTitle>
        <IonButtons slot="end">
          <IonSearchbar
            searchIcon={searchOutline}
            placeholder="Search 'Battery Pack'"
            className="ion-padding-start"
            id="search-hover-trigger"
            mode="md"
          />
          <IonPopover trigger="search-hover-trigger" triggerAction="hover">
            <IonNote class="ion-padding">Premium feature</IonNote>
          </IonPopover>
          <IonIcon
            icon={notificationsOutline}
            size="large"
            className="ion-padding-start"
            id="hover-trigger"
            mode="md"
          />
          <IonPopover trigger="hover-trigger" triggerAction="hover">
            <IonNote class="ion-padding">No notifications currently</IonNote>
          </IonPopover>
          <IonIcon
            icon={logOutOutline}
            size="large"
            className="ion-padding start ion-padding-end"
            onClick={showPopUp}
            mode="md"
          />
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default HeaderComponent;
